import React, { useState } from 'react';
import ParentCardNoCol from '../../common/ParentCardNoCol';
import { drapcodeIcon } from '../../../common/custom/icon-library';
import { convertTimeStampToDate } from '../../../common/utils/dateUtils';
import showAlert from '../../../common/utils/alert';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { Link } from 'react-router-dom';
import TooltipInfo from '../../../common/docs/TooltipInfo';
import { description } from '../../../common/utils/event_constants';

export const CustomComponentTable = ({
  projectId,
  version,
  customComponents,
  actions,
  flag,
  isReadOnly,
}) => {
  const [isModal, setIsModal] = useState(false);
  const [currentComponent, setCurrentComponent] = useState('');

  const handleDelete = (uuid) => {
    const preConfirm = () => actions.deleteCustomComponentConfig({ projectId, uuid, version });
    showAlert("You won't be able to revert it!", preConfirm, 'Yes, delete it!');
  };

  const handleClone = (customComponent) => {
    const preConfirm = async () => {
      await actions.cloneCustomComponent({
        projectId,
        customComponent,
        version,
      });
    };
    showAlert(
      `Do you want to clone ${customComponent.name} CustomComponent ?`,
      preConfirm,
      'Yes, clone it!',
    );
  };
  const renderView = () => {
    if (!isModal) return '';
    if (!currentComponent) return '';
    const {
      name,
      content: { htmlContent, customCSS, customJS },
    } = currentComponent;
    return (
      <Modal isOpen={isModal} toggle={() => setIsModal(!isModal)} backdrop="static">
        <ModalHeader toggle={() => setIsModal(!isModal)} className="border-bottom">
          <strong>Preview {name} Component</strong>
        </ModalHeader>
        <ModalBody>
          <div>{htmlContent}</div>
          <style>{customCSS}</style>
          <script>{customJS}</script>
        </ModalBody>
        <ModalFooter className="d-flex justify-content-center">
          <button className="btn btn-xs btn-primary" onClick={() => setIsModal(!isModal)}>
            <span>
              <i className={`wb ${drapcodeIcon('cancel')}`}></i>&nbsp;Cancel
            </span>
          </button>
        </ModalFooter>
      </Modal>
    );
  };

  const generateComponentRow = () => {
    if (customComponents && customComponents.length) {
      return customComponents.map((customComponent) => (
        <tr key={customComponent.uuid} className="text-left td-align-middle">
          <td>{customComponent.name}</td>
          <td>{convertTimeStampToDate(customComponent.createdAt)}</td>
          <td className="text-right">
            &nbsp;
            <Link
              className="btn btn-xs btn-primary"
              title={`Edit ${customComponent.name}`}
              to={{
                pathname: `/custom-component/${version}/v/${projectId}/customComponent/edit/${customComponent.uuid}`,
              }}
            >
              <i className="wb webconnect-pencil"></i>
            </Link>
            &nbsp;
            <button
              className="btn btn-xs btn-theme-submit"
              onClick={isReadOnly ? undefined : () => handleClone(customComponent)}
              title={isReadOnly ? `Read-Only Mode` : `Clone ${customComponent.name}`}
              disabled={isReadOnly}
            >
              <i className="wb webconnect-clone"></i>
            </button>
            &nbsp;
            <button
              className="btn btn-xs btn-theme-delete"
              onClick={() => (flag && !isReadOnly ? handleDelete(customComponent.uuid) : undefined)}
              title={isReadOnly ? `Read-Only Mode` : `Delete ${customComponent.name}`}
              style={{ cursor: flag && !isReadOnly ? 'pointer' : 'not-allowed' }}
              disabled={isReadOnly}
            >
              <i className="wb webconnect-trash-solid"></i>
              {flag ? null : (
                <>
                  &nbsp;
                  <TooltipInfo
                    title={description}
                    headerText={`Permission Disabled!`}
                    showHeader={true}
                    showArrow={true}
                  />
                </>
              )}
            </button>
          </td>
        </tr>
      ));
    } else {
      return (
        <tr>
          <td colSpan="3" className="align-middle text-center">
            No Custom Component!
          </td>
        </tr>
      );
    }
  };

  return (
    <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
      {renderView()}
      <ParentCardNoCol
        title="Custom Component"
        icon="customComponent"
        bgColor="drapcode-violet"
        CtaComponent={
          <Link
            className={`btn btn-theme-submit btn-md ${isReadOnly ? 'disabled' : ''}`}
            title={isReadOnly ? 'Read-Only Mode' : 'Create Custom Component'}
            to={{
              pathname: isReadOnly
                ? '#'
                : `/custom-component/${version}/v/${projectId}/customComponent/create`,
            }}
            onClick={(e) => {
              if (isReadOnly) {
                e.preventDefault();
              }
            }}
          >
            <i className={`wb ${drapcodeIcon('add')}`}></i> &nbsp;Create Custom Component
          </Link>
        }
      >
        <div className="table-responsive">
          <table className="table table-bordered table-hover table-sm table-word-break connector-list">
            <thead>
              <tr>
                <th>Name</th>
                <th>Created At</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>{generateComponentRow()}</tbody>
          </table>
        </div>
      </ParentCardNoCol>
    </div>
  );
};
